import React, { PropsWithChildren, createContext } from "react";

type DeviceDimensions = {
  isLargeScreen: boolean;
  isMobile: boolean;
};

export const DeviceDimensionsOverrideContext =
  createContext<DeviceDimensions | null>(null);

export const OverrideDeviceDimensions = ({
  children,
  isLargeScreen,
}: PropsWithChildren<{ isLargeScreen: boolean }>) => {
  return (
    <DeviceDimensionsOverrideContext.Provider
      value={{ isLargeScreen, isMobile: !isLargeScreen }}
    >
      {children}
    </DeviceDimensionsOverrideContext.Provider>
  );
};
